/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: EmployeesEditComponent
 * Purpose		: This component retrieves data for the specified record id and allows to edit and save changes.
 * Dependency	: EmployeesService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, OnInit, HostBinding, EventEmitter, Input, Output,
         trigger, transition, animate,
         style, state } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';
import { ToastsManager }  from 'ng2-toastr';

import { EmployeesData, EmployeesService }  from './Employees.service';



@Component({
  template: require('./EmployeesEdit.component.html'),
  providers: [EmployeesService
	
	],
  animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class EmployeesEditComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }
 
	objEmployees: EmployeesData;
	errorMessage: string;
	messages: string[];

	// Lookup Arrays
	
	EmployeesList: EmployeesData[];

	constructor(private route: ActivatedRoute, 
		private router: Router,
		private toastr: ToastsManager,
		private EmployeesService: EmployeesService

	) {
		// this.id = parseInt(params.get('id'));
		this.objEmployees = new EmployeesData();
	}

	ngOnInit() {
		this.route.params
		// (+) converts string 'id' to a number
		// .switchMap((params: Params) => this.EmployeesService.getByID(+params['id']))
		.switchMap((params: Params) => this.EmployeesService.getByID(params['id']))
		.subscribe((item: EmployeesData) => this.objEmployees = item);
		this.getLookups();
	}

	updateEmployees() {
		this.EmployeesService.updateEmployeesData(this.objEmployees)
			.subscribe(record => this.router.navigate(['/Employees']),
				error =>  this.errorMessage = 'There was an error while updating record. Error: ' + <any>error,
				() => { 
					this.toastr.success('Employees record updated successfully...', 'Edit Employees');
					console.log('Employees record updated successfully...'); 
				}
			);
	}
  
	deleteEmployees(id: string) {
		if (window.confirm('Are you sure you want to delete this Employees?') == true) 
		{
			this.EmployeesService.deleteEmployees(this.objEmployees.EmployeeID.toString())
			.subscribe(record => this.router.navigate(['/Employees']),
				error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error,
				() => { 
					this.toastr.success('Employees record deleted successfully...', 'Delete Employees');
					console.log('Employees record deleted successfully...'); 
				}
			);
		}
	}

	gotoEmployees() {
		let Id = this.objEmployees ? this.objEmployees.EmployeeID : null;
		this.router.navigate(['/Employees']);
	}

	// Get Lookup List for Employees
    getEmployees() {
		this.EmployeesService.getAll().subscribe(records => this.EmployeesList=records);
    }

	getLookups() {

        this.getEmployees();
	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Employees/EmployeesEdit.component.ts